import { z } from 'zod'

export enum TimelineSourceProvider {
  USER_FILES = 'user_files',
}

export const TimelineUserFilesSourceRefSchema = z.object({
  provider: z.literal(TimelineSourceProvider.USER_FILES),
  source_id: z.string(),
  display_name: z.string(),
})

export const TimelineSourceRefSchema = TimelineUserFilesSourceRefSchema

export type TimelineSourceRef = z.infer<typeof TimelineSourceRefSchema>
